export default "<p>\n  Logging out please wait...\n</p>\n"